import Swal from 'sweetalert2';
import { Component, OnInit } from '@angular/core';
import { AwsService, CreditosService } from '../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import { UsuarioService } from '../../services/usuario/usuario.service';
import swal2 from 'sweetalert2';
import { RolesService } from '../../services/roles/roles.service';
import { ListasService } from '../../services/listas/listas.service';
import { ParametrosGeneralesService } from '../../services/parametrosgenerales/parametrosgenerales.service';
import { info } from 'console';
@Component({
  selector: 'app-solicitudcredito',
  templateUrl: './solicitudcredito.component.html',
  styleUrls: ['./maincliente.component.css']
})
export class SolicitudcreditoComponent implements OnInit {
  paymentperiods: any[] = [];
  condiciones: any[] = [];
  monto: string;
  muestraCalculo = false;
  intereses: string;
  iva: string;
  montototal: string;
  mt: number;
  customer;
  uid;
  payments = [];
  customer_credits = [];
  solicitarCredito;
  comision = 0;
  seguro: string;
  showModalTablaAmortizacion = false;
  showModalNip = true;
  showModalNip2 = false;
  nipValidado = false;
  bandera = true;
  rates = [];
  ivaRates = [];
  fijo = false;
  pago = '';
  cols = [

    { field: 'credit_folio', header: 'Folio', moneda: false },
    { field: 'created_at', header: 'Fecha solicitud', moneda: false },
    { field: 'total_requested', header: 'Pedido Total', moneda: true },
    { field: 'interests', header: 'Intereses', moneda: true },
    { field: 'total_debt', header: 'Adeudo Total', moneda: false },
    { field: 'status', header: 'Estado', moneda: false },
  ];
  lists = [];
  credit_status = [];
  solicitud_admin = false;
  anualidad = false;
  refinanciamiento = false;
  anuality_dates = [
    {value: 'ENERO', key: '1'},
    {value: 'FEBRERO', key: '2'},
    {value: 'MARZO', key: '3'},
    {value: 'ABRIL', key: '4'},
    {value: 'MAYO', key: '5'},
    {value: 'JUNIO', key: '6'},
    {value: 'JULIO', key: '7'},
    {value: 'AGOSTO', key: '8'},
    {value: 'SEPTIEMBRE', key: '9'},
    {value: 'OCTUBRE', key: '10'},
    {value: 'NOVIEMBRE', key: '11'},
    {value: 'DICIEMBRE', key: '12'},
  ];
  customer_credit_id = '';
  customer_credit = {
    credit_info: {
      total_requested: ''
    },
    credit_payments: {}
  };
  signatories = {};
  customer_credits_rejected = [];
  customer_credits_eval = [];
  period_anuality = true;
  monto_anualidad: any;
  anuality_date = 'na';
  exclude_limit = false;
  exclude_senority = false;
  indicadorPosicion: string;
  has_guarantee_object = false;
  guarantee_object = '';
  guarantee_object_address = '';
  guarantee_email = '';
  customer_gov_id = '';
  creditoYucatan = false;
  customer_gov: void;
  gov_rate = '30';
  capacidadMaxima = 0;
  capacidadExcedida = false;
  pagoFijo: number;
  segundo = false;
  soyunita = localStorage.getItem('quiensoy') === 'unita';
  soybankaool = localStorage.getItem('quiensoy') === 'bankaool';
  refinanciamientoItems = [{ company_id: null, total_credit: null, reference: '', attached: null }];
  financialCompanies = [];

  // CREDITOS-REVOLVENTES: parámetros generales que controlan el feature.
  // creditoRevolventeActivo: el parámetro CREDITO_REVOLVENTE está en SI.
  // porcentajeMinimoRevolvente: % mínimo pagado para poder reestructurar (default 30).
  creditoRevolventeActivo = false;
  porcentajeMinimoRevolvente = 30;

  // CREDITOS-REVOLVENTES (Paso 2): crédito revolvente activo del cliente (si existe)
  // y bandera de si el flujo actual es una reestructuración. Solo aplica a GPA.
  creditoRevolventeCliente: any = null;
  esReestructuracion = false;

  // CREDITOS-REVOLVENTES (Paso 3): monto que el cliente puede volver a solicitar
  // y validación del porcentaje mínimo pagado (default 30%).
  // montoDisponibleRevolvente = total_requested - revolving_pending_balance
  // porcentajePagadoRevolvente = (pagado / total_requested) * 100
  // cumpleMinimoRevolvente = porcentajePagado >= porcentajeMinimoRevolvente
  montoDisponibleRevolvente = 0;
  porcentajePagadoRevolvente = 0;
  cumpleMinimoRevolvente = false;


  constructor( private creditosService: CreditosService,
                public router: Router,
                private route: ActivatedRoute,
                private usuarioService: UsuarioService,
                private rolesService: RolesService,
                private listasService: ListasService,
                private parametrosService: ParametrosGeneralesService,
                private aws: AwsService  ) { }

  ngOnInit(){
    // CREDITOS-REVOLVENTES (Paso 1): leer parámetros generales que controlan el feature.
    // Solo lee y guarda; la lógica de reestructuración se aplica en pasos posteriores
    // y únicamente para GPA (no gobierno/yucatán).
    this.parametrosService.getParametros().subscribe((params: any[]) => {
      const pRevolvente = params.find(p => p.key === 'CREDITO_REVOLVENTE');
      this.creditoRevolventeActivo = !!pRevolvente && (pRevolvente.value || '').toString().toUpperCase() === 'SI';

      const pPorcentaje = params.find(p => p.key === 'PORCENTAJE_MINIMO_REVOLVENTE');
      if (pPorcentaje && pPorcentaje.value != null && pPorcentaje.value !== '') {
        const val = parseFloat(pPorcentaje.value);
        if (!isNaN(val)) { this.porcentajeMinimoRevolvente = val; }
      }
    }, err => {
      console.log('No se pudieron leer los parámetros de créditos revolventes', err);
    });

    this.listasService.getLists().subscribe(lists => {
      lists['data'].forEach(list => {
        this.lists.push(list.attributes);
      });
      this.credit_status = this.lists.filter(p => p.domain === 'CREDIT_STATUS');
    })
    this.creditosService.getperiodosPagos().toPromise().then ( resp => this.paymentperiods = resp );
    this.creditosService.ext_rates().subscribe(resp => {
      resp['data'].forEach(rate => {
        if(rate.attributes.rate_type === 'TA'){
          this.rates.push(rate.attributes);
        }else if(rate.attributes.rate_type === 'IVA'){
          this.ivaRates.push(rate.attributes);
        }
      });
    })

    if(this.route.snapshot.paramMap.get('customer_credit_id')){
      this.solicitud_admin = true;
      this.customer_credit_id = this.route.snapshot.paramMap.get('customer_credit_id');
      this.creditosService.getCredit(this.customer_credit_id).subscribe(resp => {
        this.customer_credit = {credit_info: resp['data']['attributes'], credit_payments: resp['data']['relations']['current_payments']}
        this.uid = this.customer_credit['credit_info']['user_id'];
        this.getCustomer();
        this.indicadorPosicion = 'aprobar'
      })
    }else if(this.route.snapshot.paramMap.get('user_id')){
      this.uid = this.route.snapshot.paramMap.get('user_id');
      this.solicitud_admin = true;
      this.getCustomer();
      this.indicadorPosicion = 'simulador'
    } else if(this.route.snapshot.paramMap.get('customer_gov_id')){
      this.customer_gov_id = this.route.snapshot.paramMap.get('customer_gov_id');
      this.solicitud_admin = true;
      this.solicitarCredito = false;
      this.creditoYucatan = true;
      this.getCustomerGov();
      
    }else{
      console.log('entra normal')
      // Funcionamiento normal, cliente haciendo solicitud
      this.uid = localStorage.getItem('uid');
      this.getCustomer();
      this.solicitud_admin = false;
      this.indicadorPosicion = 'na'
      if(localStorage.getItem('sec') && localStorage.getItem('sec') == 'true'){
        this.segundo = true;
      }
    }

    
    
  }

  clicRefinanciamiento(){
    this.refinanciamiento = !this.refinanciamiento;
    this.aws.getFinancialCompanies().subscribe(resp => {
      this.financialCompanies = resp;
    })
  }

  // REVISADAS

  getCustomerGov(){ 
    this.usuarioService.getGovCustomer(this.customer_gov_id).subscribe(resp => {
      this.customer_gov = resp;
      this.capacidadMaxima = parseFloat(this.customer_gov['data']['relations'].gov_customers[0].attributes.payment_capacity);
      var piDocs = this.customer_gov['data']['relations'].contributor_documents.filter(doc => doc.attributes.status == 'PI');
      if((piDocs.length > 1 ) || (piDocs.length == 1 && !piDocs[0].attributes.name.toLowerCase().includes('domicilio'))){
        swal2.fire('Atención', 'Faltan documentos por cargar', 'info').then(result => {
          if(result.isConfirmed){
            this.router.navigate([`panelcontrol/empleadosGobierno/altaEmpleado/${this.customer_gov_id}`]);
          }
        })
      }
      this.creditosService.getCondiciones().subscribe( resp => {
        this.condiciones = resp.filter(c => c.term_type.toUpperCase() === this.customer_gov['data']['relations'].gov_customers[0].attributes.salary_period.toUpperCase() && c.extra1 != 'CUSTOM')
        this.pago = 'plazo';
      } );
      return resp;
    })
  }

  getCustomer(){
    this.usuarioService.getCustomer(this.uid).subscribe(resp => {
        this.configuracionPantalla(resp);
      });
  }

  configuracionPantalla(resp){
    console.log('resp', resp);
    this.customer = resp['data'].relations.customers[0].attributes;
      this.creditosService.getCondiciones().subscribe( resp => {
        this.condiciones = resp.filter(c => c.term_type.toUpperCase() === this.customer.salary_period.toUpperCase() && c.extra1 != 'CUSTOM')
        console.log('condiciones', this.condiciones)
        this.pago = 'plazo';
      } );
      this.creditosService.getCredits().subscribe(resp2 => {
        let creditos_totales = [];
        Object.keys(resp2['data']).forEach(key => {
          let credit = resp2['data'][key].attributes;
          try{
            let status = this.credit_status.find(s => s.key == credit.status);
            credit.status = status.value;
          }catch{}
          creditos_totales.push(credit);
        })
        this.customer_credits = creditos_totales.filter(credito => credito.customer_id === this.customer.id && credito.status != 'REVISADO' && credito.status != 'LIQUIDADO' && credito.status != 'RECHAZADO');
        this.customer_credits_rejected = creditos_totales.filter(credito => credito.customer_id === this.customer.id && credito.status == 'RECHAZADO');

        // CREDITOS-REVOLVENTES (Paso 2): detectar si el cliente tiene un crédito
        // revolvente activo (de la lista ya filtrada arriba). Solo para el CLIENTE en
        // GPA (no gobierno, no admin) y solo si el parámetro CREDITO_REVOLVENTE está
        // en SI. Si lo tiene, el flujo será una reestructuración (en pasos siguientes
        // se calcula el monto y se confirma con status AC).
        // El admin, aunque entre a esta misma pantalla a editar, NO entra en modo
        // revolvente (por eso se excluye solicitud_admin: así no le aparece el banner).
        if (this.creditoRevolventeActivo && !this.creditoYucatan && !this.solicitud_admin) {
          this.creditoRevolventeCliente = this.customer_credits.find(c => c.revolving_credit === true) || null;
          this.esReestructuracion = this.creditoRevolventeCliente != null;
          this.calcularDisponibleRevolvente();
        } else {
          this.creditoRevolventeCliente = null;
          this.esReestructuracion = false;
        }
        if(this.customer_credits_rejected.length > 0){
          swal2.fire('Atención', 'El crédito solicitado fue rechazado anteriormente, contacte al administrador para más detalles', 'info');
        }
        if(this.customer_credits.length > 0){
          console.log('aqui toy')
          // CREDITOS-REVOLVENTES: si es reestructuración (el cliente llega desde
          // "solicitar nuevo crédito" en maincliente y ya tiene revolvente activo),
          // se muestra DIRECTO el formulario de solicitud, no la tabla de créditos.
          // Así se evita el doble clic (antes quedaba en la tabla y había que volver
          // a dar "Solicitar nuevo crédito").
          this.solicitarCredito = this.esReestructuracion;
        }else{
          this.solicitarCredito = true;
          this.customer_credits_eval = creditos_totales.filter(credito => credito.customer_id === this.customer.id)
          if(this.customer_credits_eval.length > 0){
            this.resetNip();
          }
        }

      })
  }

  /**
   * CREDITOS-REVOLVENTES (Paso 3): calcula el monto que el cliente puede volver
   * a solicitar en una reestructuración y valida el porcentaje mínimo pagado.
   *   montoDisponible = total_requested - revolving_pending_balance
   *   porcentajePagado = (pagado / total_requested) * 100   (pagado = montoDisponible)
   *   cumpleMinimo = porcentajePagado >= porcentajeMinimoRevolvente (default 30)
   * Solo calcula cuando hay una reestructuración detectada (GPA).
   */
  calcularDisponibleRevolvente(){
    this.montoDisponibleRevolvente = 0;
    this.porcentajePagadoRevolvente = 0;
    this.cumpleMinimoRevolvente = false;

    if (!this.esReestructuracion || !this.creditoRevolventeCliente) { return; }

    const totalSolicitado = parseFloat(this.creditoRevolventeCliente.total_requested);
    const saldoPendiente = parseFloat(this.creditoRevolventeCliente.revolving_pending_balance);

    // Si el saldo aún no está cargado (NaN/undefined), no se puede reestructurar todavía.
    if (isNaN(totalSolicitado) || totalSolicitado <= 0 || isNaN(saldoPendiente)) {
      this.montoDisponibleRevolvente = 0;
      this.porcentajePagadoRevolvente = 0;
      this.cumpleMinimoRevolvente = false;
      return;
    }

    const pagado = totalSolicitado - saldoPendiente;
    this.montoDisponibleRevolvente = pagado > 0 ? pagado : 0;
    this.porcentajePagadoRevolvente = (pagado / totalSolicitado) * 100;
    this.cumpleMinimoRevolvente = this.porcentajePagadoRevolvente >= this.porcentajeMinimoRevolvente;
  }

  showModalNip2now(){
    (document.getElementById('btnSolicitar') as HTMLButtonElement).disabled = true;
    this.showModalNip2 = true;
  }

  validarNip(){
    // VALIDA EL NIP POR PRIMERA VEZ Y MUESTRA 
    var nip = (document.getElementById('nip') as HTMLInputElement).value;
    // ENVIA EL CUSTOMER ID
    this.usuarioService.getNipStatus(nip,this.customer).subscribe( resp => {
      if ( resp.status !== true ) {
        swal2.fire(
        'El NIP es incorrecto',
        'Intente de nuevo',
        'error'
        
     ).then(okay => {
      // if (okay) {
        swal2.close();
       this.focusNip();
    //  }
   });
      this.showModalNip = true;
      this.nipValidado = false;
      (document.getElementById('nip') as HTMLInputElement).value = ''

    } else {
      swal2.fire('Éxito', 'NIP validado correctamente', 'success');
          this.showModalNip = false;
          this.nipValidado = true;
          }
      }
      );  
  }

  validarNip2(){
    (document.getElementById('btnValidar') as HTMLButtonElement).disabled = true;
    // VALIDA EL NIP POR SEGUNDA VEZ Y CREAR EL CREDITO COMO SO
    var nip = (document.getElementById('nip2') as HTMLInputElement).value;
    this.usuarioService.getNipStatus(nip,{id: this.customer.id}).subscribe( resp => {
      if ( resp.status !== true ) {
        swal2.fire(
        'El NIP es incorrecto',
        'Intente de nuevo',
        'error'
        );
        this.showModalNip2 = true;
        this.nipValidado = false;
        (document.getElementById('nip2') as HTMLInputElement).value = ''
      } else {
        swal2.fire('Éxito', 'NIP validado correctamente', 'success');
        this.showModalNip2 = false;
        this.nipValidado = true;
        // console.log("AQUI VA A MANDAR A GUARDAR EL CREDITO COMO SO")

        this.calcular('SO')

      }
    });
  }

  resetNip(){
    // SERVICIO PARA GENERAR NUEVO NIP
    this.usuarioService.resetNip(this.customer).subscribe( resp => {
      if ( resp.status !== true ) {
        swal2.fire(
        'Ha ocurrido un error',
        'Vuelva a intentarlo',
        'error'
     );
    } else {
      swal2.fire('Se le ha enviado un nuevo NIP', 'Revise su correo', 'success');
          }
      }
      );  
  }

  focusNip() {
    var input = (document.getElementById('nip')as HTMLInputElement);
    input.focus();
  }

  showTablaAmortizacion() {
    this.showModalTablaAmortizacion = true; // Show-Hide Modal Check
  }

  hideModalTablaAmortizacion() {
    this.showModalTablaAmortizacion = false;
  }  

  showModalTablaAmortizacionActivos(id) {
    this.payments = [];
    this.creditosService.customerCreditPayments(id).subscribe(pays => {
      pays['data'].forEach(p => {
        this.payments.push(p['attributes']);
      });
    });
    
    this.showModalTablaAmortizacion = true; // Show-Hide Modal Check
  }

  // para validar y limitar el número de decimales en tiempo real
  validateInput(event: any) {
    var value = this.creditosService.limitarDecimales(event);
    this.customer_credit['credit_info']['total_requested'] = value;
  }
  
  // Para cuando pierda el foco formatear
  fmCurrency(event: any) {
    var value = this.creditosService.formatearFocoPerdido(event);
    this.customer_credit['credit_info']['total_requested'] = value;
  }

  calcular(status) {
    // CREDITOS-REVOLVENTES (Paso 4): ¿este flujo es una reestructuración revolvente?
    // Solo cuando hay revolvente activo detectado, es GPA (no gobierno) y es el
    // cliente (no admin). En ese caso se valida en el front y se usa status AC al confirmar.
    const esReestructuracionRevolvente = this.esReestructuracion && !this.creditoYucatan && !this.solicitud_admin;

    if (esReestructuracionRevolvente) {
      // Regla del 30%: solo se puede reestructurar si ya pagó el mínimo requerido.
      if (!this.cumpleMinimoRevolvente) {
        swal2.fire(
          'Aún no es posible solicitar más crédito',
          `Debes haber pagado al menos el ${this.porcentajeMinimoRevolvente}% de tu crédito actual. ` +
          `Llevas pagado ${this.porcentajePagadoRevolvente.toFixed(2)}%.`,
          'info'
        );
        return;
      }
      // El monto solicitado no puede exceder el disponible.
      const montoTecleado = parseFloat((document.getElementById('monto') as HTMLInputElement).value.replace(/,/g, ''));
      if (!isNaN(montoTecleado) && montoTecleado > this.montoDisponibleRevolvente) {
        swal2.fire(
          'Monto no disponible',
          `El monto máximo que puedes solicitar es $${this.montoDisponibleRevolvente.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}.`,
          'info'
        );
        return;
      }
    }

    // Validación de refinanciamiento
    if (this.refinanciamiento) {
      if (this.refinanciamientoItems.length === 0) {
        swal2.fire('Refinanciamiento incompleto', 'Debes agregar al menos un registro de refinanciamiento.', 'info');
        return;
      }
      for (let i = 0; i < this.refinanciamientoItems.length; i++) {
        const item = this.refinanciamientoItems[i];
        const faltantes: string[] = [];
        if (!item.company_id) faltantes.push('Empresa financiera');
        if (!item.total_credit) faltantes.push('Saldo a liquidar');
        if (!item.reference || item.reference.trim() === '') faltantes.push('Referencia');
        if (faltantes.length > 0) {
          swal2.fire(
            `Refinanciamiento - Registro ${i + 1} incompleto`,
            `Faltan los siguientes campos: ${faltantes.join(', ')}`,
            'info'
          );
          return;
        }
      }
    }

    // swal2.showLoading();
    Swal.fire({
      title: 'Procesando petición',
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
          Swal.showLoading()
      },
    });
    
    this.monto = (document.getElementById('monto')as HTMLInputElement).value.replace(/,/g, '');
    if (this.monto === '' || parseInt(this.monto) < 0) {
      Swal.fire('Valor inválido', 'El valor debe contener un valor y ser mayor a 0', 'info');
    } else {      
      let date = new Date();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();  
      let start_date;

      if(month < 10){
        start_date =  `${year}-0${month}-${day}`;
      }else{
        start_date = `${year}-${month}-${day}`;
      }

      const params = {};

      // CREDITOS-REVOLVENTES (Paso 4): en reestructuración, al CONFIRMAR el cliente
      // (status SO) se envía AC. La simulación (SI) se mantiene igual.
      let statusEfectivo = status;
      if (esReestructuracionRevolvente && status === 'SO') {
        statusEfectivo = 'AC';
      }

      let customer_credit = {
        total_requested: this.monto,
        status: statusEfectivo,
        start_date: start_date,
        currency: 'PESOS',
        has_guarantee_object: this.has_guarantee_object,
        guarantee_object: this.guarantee_object,
        guarantee_object_address: this.guarantee_object_address,
        guarantee_email: this.guarantee_email,
        refinancing: this.refinanciamiento
      }

      // CREDITOS-REVOLVENTES (Paso 4): el revolvente entra por el mismo endpoint
      // enviando requested_amount (lo que el cliente solicita de lo ya pagado).
      if (esReestructuracionRevolvente) {
        params['requested_amount'] = this.monto;
      }
      
      
      if(this.anualidad){
        let monto_anualidad = (document.getElementById('monto_anualidad') as HTMLInputElement).value;
        if(monto_anualidad != '' && parseInt(monto_anualidad) > 0){
          params['anuality'] = this.monto_anualidad;
          params['anuality_date'] = parseInt(this.anuality_date);
          params['period_anuality'] = this.period_anuality;
        }else{
          Swal.fire('Valor de anualidad inválido', 'El valor debe contener un valor y ser mayor a 0', 'info');
        }
      }
      if(this.creditoYucatan){
        customer_credit['gov_customer_id'] = this.customer_gov_id;
        customer_credit['user_id'] = localStorage.getItem('uid');
        customer_credit['iva_percent'] = this.ivaRates.find(r => r.description == 'No Fronteriza').value;
        if(this.refinanciamiento){
          params['fin_credit_details'] = this.refinanciamientoItems;
        }
      }else{
        customer_credit['customer_id'] = this.customer.id;
        customer_credit['user_id'] = this.uid;
        customer_credit['iva_percent'] = (document.getElementById('fronterizo') as HTMLInputElement).value;
      }



      if(this.pago == ''){
        swal2.fire('Datos incompletos', 'Debes seleccionar un método de pago', 'info');
        return;
      }else if(this.pago == 'plazo'){
        customer_credit['term_id'] = (document.getElementById('Condicione')as HTMLInputElement).value;
      }else if(this.pago == 'fijo'){
        params['payment_amount'] = (document.getElementById('pagoFijo')as HTMLInputElement).value;
      }
      params['customer_credit'] = customer_credit;

      params['old_customer_credit'] = this.customer_credit_id;
      
      params['exclude_limit'] = this.exclude_limit;
      params['exclude_senority'] = this.exclude_senority;

      console.log(params);

      this.creditosService.customerCredit(params).subscribe(resp => {
        console.log(resp)
        swal2.close();
        this.muestraCalculo = true;
        this.payments = [];
        resp['data'].relations.current_payments.forEach(payment => {
          this.payments.push(payment.attributes);
        });
        this.monto = resp['data'].attributes.total_requested;
        this.intereses = resp['data'].attributes.interests;
        this.iva = resp['data'].attributes.iva;
        this.comision = resp['data'].attributes.commission1;
        this.seguro = resp['data'].attributes.insurance1;
        this.montototal = resp['data'].attributes.total_debt;
        this.pagoFijo = parseFloat(resp['data'].attributes.fixed_payment);
        if(status === 'SI' && this.creditoYucatan){
          if(parseFloat(resp['data'].attributes.fixed_payment) > this.capacidadMaxima){
            this.capacidadExcedida = true;
          }else{
            this.capacidadExcedida = false;
          }
        }
        // CREDITOS-REVOLVENTES: la reestructuración se confirma en AC (crédito ya
        // aprobado). Al confirmar (status SO del cliente convertido a AC) NO debe
        // quedar en la pantalla de solicitud permitiendo pedir otra vez: se muestra
        // el éxito y se regresa a maincliente. El flag esReestructuracion solo es
        // true cuando es el cliente reestructurando un revolvente (GPA).
        if(status === 'SO' && this.esReestructuracion){
          swal2.fire('Éxito', 'Tu crédito revolvente fue reestructurado correctamente.', 'success').then(() => {
            this.router.navigate(['/maincliente']);
          });
        }
        else if(status === 'SO'){
          // Tras solicitar el crédito (SO), regresar a maincliente en vez de recargar
          // la pantalla de solicitud. Antes hacía ngOnInit()+reload(), lo que volvía a
          // mostrar el formulario y reenviaba el NIP. El crédito queda en revisión;
          // el cliente debe esperar a que el administrador lo trate.
          localStorage.removeItem('sec');
          this.segundo = false;
          swal2.fire('Éxito', 'Estamos revisando tu solicitud, nos contactaremos contigo pronto', 'success').then(() => {
            this.router.navigate(['/maincliente']);
          });
        }
        
        else if(status === 'PA'){
          if(this.customer_credit_id != ''){
            try{
              this.creditosService.updateCredit(this.customer_credit_id, {status: 'RE'}).subscribe(() => {
                console.log(resp);
                this.creditosService.getSignatoriesByCreditId(this.customer_credit_id).subscribe(st => {
                  this.signatories = st['signatories'];
                  Object.keys(this.signatories).forEach(signatory => {
                    this.creditosService.updateSignatory(this.signatories[signatory].id, resp['data'].id).subscribe();
                  })
                }, err => {
                  console.log('Algo salió mal', err.error.errors[0])
                })
              },error => {
                console.log(error);
                try{
                  swal2.fire('Atención', error.error.error, 'info');
                }catch{
                  swal2.fire('Atención', 'Algo salió mal', 'info');
                }
              })
              // swal2.fire('Atención', err.error.error, 'info');
            }catch{
              swal2.fire('Atención', 'Algo salió mal', 'info');
            }
          }
            
          Swal.fire('Éxito', 'Crédito solicitado con éxito', 'success').then((result) => {
            if (result.isConfirmed) {
              if (this.creditoYucatan) {
                this.router.navigate(['/panelcontrol/empleadosGobierno/']);
              } else {
                this.router.navigate(['/panelcontrol/aprobarCreditos/']);
              }
            }
          });
        }

      }, err => {
        console.log('err', err);
        // Al fallar la simulación/solicitud: solo mostrar el error y limpiar la
        // información del cálculo. NO se recarga la pantalla (ngOnInit) ni se
        // reenvía el NIP; antes se llamaba a ngOnInit() y eso reiniciaba el flujo
        // (mostraba el aviso de "crédito rechazado anteriormente" y reenviaba el NIP).
        this.muestraCalculo = false;
        this.limpiarCalculo();
        if(err && err.error && err.error.errors){
          swal2.fire('Atención', err.error.errors[0], 'info');
        }else if(err && err.error && err.error.error){
          swal2.fire('Atención', err.error.error, 'info');
        }else{
          swal2.fire('Algo salió mal', 'Contacte al Administrador', 'info');
        }
      })
    }
  
  }
  /**
   * Limpia la información del cálculo/simulación sin recargar la pantalla.
   * Se usa cuando la petición falla, para dejar la vista limpia pero sin
   * reiniciar el flujo (no reenvía NIP ni vuelve a cargar créditos).
   */
  limpiarCalculo() {
    this.payments = [];
    this.monto = '';
    this.intereses = '';
    this.iva = '';
    this.comision = 0;
    this.seguro = '';
    this.montototal = '';
    this.pagoFijo = null;
    this.capacidadExcedida = false;
    this.customer_credit['credit_info']['total_requested'] = '';
    const inputMonto = document.getElementById('monto') as HTMLInputElement;
    if (inputMonto) { inputMonto.value = ''; }
  }

  addRefinanciamientoItem() {
    this.refinanciamientoItems.push({company_id: null, total_credit: null, reference: '', attached: null });
  }

  removeRefinanciamientoItem(index: number) {
    this.refinanciamientoItems.splice(index, 1);
  }
  
  async fileBrowseHandler( event: any, index ) {
      const file: File = event.target.files[0];
  
    if (file) {
      const isPdf = file.type === 'application/pdf';
      const isImage = file.type.startsWith('image/');
      if (!isPdf && !isImage) {
        swal2.fire('Atención', 'Solo se permiten archivos PDF o imágenes (JPG, PNG, etc.)', 'info');
        event.target.value = '';
        return;
      }
    }
      await this.callupload(file, index);
    }
  
    async callupload(file: File, index: number) {
      try {
        const r = await this.aws.uploadFileSB(file, this.customer_gov_id);
        console.log(r, r['url']);
        this.refinanciamientoItems[index].attached = r['url'];
      } catch (error) {
        console.log('error', error);
        let resp = {
          status: false,
          resp: error,
          msg: 'Fallo al subir archivo'
        }
        try{
          swal2.fire(error.error.error, error.error.exception, 'info');
        }catch{
          swal2.fire('Error', 'Ocurrió algo en la carga', 'info')
        }
        return resp
      }
    }


}
